// actions
import { STARTOVERBTN_UPDATE_LABEL } from './actions';

const StartOverBtn = (state = {
  label: '',
}, action) => {
  switch (action.type) {
    case STARTOVERBTN_UPDATE_LABEL:
      return {
        ...state,
        label: action.label,
      };
    default:
      return state;
  }
};

export default StartOverBtn;
